import { LocaleLangE } from "../i18n/LocaleContext";

export const saveLangToLocal = (lang: LocaleLangE) => {
  localStorage.setItem("lang", lang);
};

export const getLangFromLocal = () =>
  (localStorage.getItem("lang") as LocaleLangE) || LocaleLangE.RU;
